<div class="uk-grid uk-child-width-1-{{columns}}@s" uk-grid>
  <div *ngFor="let item of cards">
    <div class="uk-card uk-card-default uk-card-small uk-card-hover uk-animation-slide-bottom-small">
      <div class="uk-card-header uk-animation-slide-bottom-small">
        <div class="uk-grid uk-grid-small uk-flex-middle" uk-grid>
          <div class="uk-width-auto">
            <img [class.uk-border-circle]="circularLogos" width="40" height="40" src="{{item.logo}}">
          </div>
          <div class="uk-width-expand">
            <h3 class="uk-card-title uk-margin-remove-bottom">{{item.title}}</h3>
            <p class="uk-text-meta uk-margin-remove-top">
              <time datetime="2016-04-01T19:00">{{item.subtitle}}</time>
            </p>
          </div>
        </div>
      </div>
      <div class="uk-card-body">
        <p class="uk-text-meta">
          {{item.time}}
        </p>
        <p>{{item.mainText}}</p>
      </div>
    </div>
  </div>
</div>
